import { GET_LOCATIONS} from '../actions/types';

const location_data = {
  locations: [],
};

export default (state = location_data, action) => {

  switch (action.type) {   
    case GET_LOCATIONS:         
      var  newdata = action.payload.dataArray
      return {  
        locations: newdata,      };


    default:
      return state;
  }
};
